import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getArchiveList, getArchiveListWithoutDelay } from 'features/todolist/store/actions'
import { toggleCompleteTaskRequest } from 'features/task/store/actions'
import { openPanel } from 'features/taskPanel/store/actions'
import { removeTask, updateTask, patchTaskRequest } from 'features/task/store/actions'
import { findById } from 'features/list/utils'
import { getGroupedArchive, getLastSortKey } from 'features/todolist/store/selectors'
import { scrollAndHighlightElementWithId } from 'features/app/store/actions'
import { markTaskAsRead, markArchiveTasksWithUpdatesAsRead } from 'features/notifications/store/actions'
import { constants, utils } from 'gipsy-misc'
import qs from 'qs'

const mapStateToProps = state => ({
  completedTasks: getGroupedArchive(state),
  lastSortKey: getLastSortKey(state),
  highlightIds: state.todolist.highlightIds
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getArchiveList,
      getArchiveListWithoutDelay,
      toggleCompleteTaskRequest,
      openPanel,
      removeTask,
      markTaskAsRead,
      markArchiveTasksWithUpdatesAsRead,
      scrollAndHighlightElementWithId,
      findById,
      updateTask,
      patchTaskRequest
    },
    dispatch
  )
})

export default function wrapper(Component) {
  class ArchivePageContainer extends PureComponent {
    lastSortKey = ''
    resetWaypoint = false
    constructor(props) {
      super(props)

      const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

      if (queryParams.scrollto) {
        this.props.actions.scrollAndHighlightElementWithId(queryParams.scrollto)
      }

      if (queryParams.open) {
        this.props.actions.openPanel(queryParams.open)
      }

      this.load()
    }

    load = async () => {
      await this.props.actions.getArchiveListWithoutDelay('', constants.limitPaginationArchive)
      this.didLoad = true
    }

    onComplete = ({ id, paramName, value }) => {
      this.props.actions.toggleCompleteTaskRequest(id, value)
      this.timeout = setTimeout(() => {
        this.props.actions.removeTask(id)
      }, 2000)
    }

    onClick = async taskId => {
      await this.props.actions.openPanel(taskId)
      const numNotifs = await this.props.actions.markTaskAsRead(taskId)
      if (numNotifs > 0) {
        this.props.actions.getArchiveList(this.props.lastSortKey, 0, 'greaterThanEqual')
        this.resetWaypoint = true
      }
    }

    patchers = {}

    onChange = (taskId, { paramName, value, method = 'change' }) => {
      let task = this.props.actions.findById(taskId)

      const { params, body } = utils.task.computePatchRequest(task, { paramName, value, method })

      let newTask = utils.task.computeTaskOnChange(task, {
        paramName: paramName,
        value: value,
        method: method
      })
      this.props.actions.updateTask(newTask)
      if (!this.patchers[taskId]) {
        this.patchers[taskId] = new utils.TaskPatcher(constants.delayBeforePatch.default)
      }
      return new Promise((resolve, reject) => {
        this.patchers[taskId].put(paramName, method, () => {
          return this.props.actions
            .patchTaskRequest(task.id, params, body)
            .then(args => {
              resolve(args)
            })
            .catch(reject)
        })
      })
    }

    onEnterWaypoint = () => {
      const lastSortKey = this.props.lastSortKey
      if (!this.resetWaypoint && (!this.didLoad || !lastSortKey || this.lastSortKey === lastSortKey)) {
        return
      }
      this.resetWaypoint = false
      this.lastSortKey = lastSortKey
      this.props.actions.getArchiveListWithoutDelay(lastSortKey, constants.limitPaginationArchive)
    }

    onMarkAllAsRead = async () => {
      await this.props.actions.markArchiveTasksWithUpdatesAsRead()
      this.props.actions.getArchiveList(this.props.lastSortKey, 0, 'greaterThanEqual')
      this.resetWaypoint = true
    }

    render() {
      const { completedTasks, highlightIds, lastSortKey } = this.props
      return (
        <Component
          completedTasks={completedTasks}
          onComplete={this.onComplete}
          onClick={this.onClick}
          onChange={this.onChange}
          lastSortKey={lastSortKey}
          onEnterWaypoint={this.onEnterWaypoint}
          onMarkAllAsRead={this.onMarkAllAsRead}
          highlightIds={highlightIds}
        />
      )
    }
  }

  const containerRedux = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
      pure: true
    }
  )(ArchivePageContainer)

  return containerRedux
}



// WEBPACK FOOTER //
// ./src/pages/todolist/archivePage/container.js